const normalizeFieldValues = (field_type, values = []) => {
  switch (field_type) {
    case 'StatusField':
      return values.map(v => ({label: v[0], value: v[1]}))
    case 'ListField':
    case 'MultipleListField':
      return values.map(v => ({label: v, value: v}))
    case 'EntityListField':
    case 'MultipleEntityListField':
      return values.map(v => ({label: v[0], value: v[1]['$oid']}))
    case 'ApUserField':
      return values.map(v => ({label: v[0], value: v[1]}))
    default:
      return values.map(v => ({label: v, value: v}))
  }
}

export {normalizeFieldValues}
